import { isValidElementType } from 'react-is';
import { func, object, arrayOf, oneOfType, element, shape } from 'prop-types';

export function falsy(props, propName, componentName) {
  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
}

export var history = shape({
  listen: func.isRequired,
  push: func.isRequired,
  replace: func.isRequired,
  go: func.isRequired,
  goBack: func.isRequired,
  goForward: func.isRequired
});

export var component = function component(props, propName, componentName) {
  if (Object.prototype.hasOwnProperty.call(props, propName) && !isValidElementType(props[propName])) {
    throw new Error('Invalid prop `' + propName + '` supplied to `' + componentName + '`.');
  }
};
component.isRequired = function (props, propName, componentName) {
  if (!Object.prototype.hasOwnProperty.call(props, propName)) {
    throw new Error('Prop `' + propName + '` is required in `' + componentName + '`.');
  }
  return component(props, propName, componentName);
};
export var components = oneOfType([component, object]);
export var route = oneOfType([object, element]);
export var routes = oneOfType([route, arrayOf(route)]);